export const PERK_DETAIL_ALIASES = {
  boon_circle_of_healing: 'circle_of_healing',
  boon_dark_theory: 'dark_theory',
  boon_exponential: 'exponential',
  boon_shadow_step: 'shadow_step',
  detective_s_hunch: 'detectives_hunch',
  invocation_treacherous_crows: 'treacherous_crows',
  plunderer_s_instinct: 'plunderers_instinct',
  quick_quiet: 'quick_and_quiet',
  we_ll_make_it: 'well_make_it',
  we_re_gonna_live_forever: 'were_gonna_live_forever',
  bound_by_obsession: 'object_of_obsession',
  down_to_the_last: 'sole_survivor',
  will_to_live: 'decisive_strike',
  barbecue_chilli: 'barbecue_chili',
  hex_blood_favour: 'hex_blood_favor',
  cull_the_weak: 'dying_light',
  hex_fortune_s_fool: 'hex_plaything',
  keep_them_waiting: 'save_the_best_for_last',
  no_holds_barred: 'deadlock',
  scourge_hook_weeping_wounds: 'scourge_hook_gift_of_pain',
  see_how_they_run: 'play_with_your_food'
}

export const PERK_DESCRIPTION_OVERRIDES = {
  babysitter: {
    sourceName: 'Babysitter',
    officialDescription: "Whenever you unhook another Survivor, the Killer's Aura is revealed to you for 8 seconds.\nThe unhooked Survivor suppresses Scratch Marks and Pools of Blood and gains +10% stronger Haste for 20/25/30 seconds."
  },
  wide_open_throttle: {
    sourceName: 'Wide Open Throttle',
    officialDescription: 'Fast-vaulting a Pallet triggers the following effects:\nGain 10/12.5/15% Haste for 3 seconds.\nThe Pallet is immediately reset and blocked by the Entity for 60 seconds.\nThis perk then goes on a 60 second cool-down.'
  },
  lend_a_hand: {
    sourceName: 'Lend a Hand',
    officialDescription: 'Cleansing or Blessing a Totem activates this perk.\nOnce per Survivor, while healing a Survivor, press Activate Ability 2 to give the healed Survivor 2/3/4 permanent healing charges.'
  },
  cross_examination: {
    sourceName: 'Cross-Examination',
    officialDescription: "While inside the Killer's Terror Radius and not being chased, the Killer leaves behind Light Marks that you can see. Light Marks have a duration of 10 seconds.\nWhile standing on a Light Mark, gain Elusive. This lingers for 3/4/5 seconds."
  },
  hex_scared_to_death: {
    sourceName: 'Hex: Scared to Death',
    officialDescription: 'When you Hook 3 different Survivors, Hex: Scared to Death activates on a random Totem.\nBasic-breaking a Pallet during a chase causes all Survivors within 13 metres to scream and gain 11/12/13% Hindered for 3 seconds.\nThe Hex persists until its Totem is blessed or cleansed.'
  },
  silent_shadow: {
    sourceName: 'Silent Shadow',
    officialDescription: 'When you hook a Survivor, you are granted Undetectable for 11/12/13 seconds.\nWhen the Exit Gates are powered, you are granted Undetectable for the rest of the Trial.'
  },
  rampage: {
    sourceName: 'Rampage',
    officialDescription: 'Whenever you basic-break a Pallet or a Breakable Wall, gain a Token, up to 13.\nWhenever you are blinded or Pallet-stunned, you are granted 1% Haste for each Token for 13 seconds.\nThis perk has a cool-down of 30/25/20 seconds after being blinded or Pallet-stunned.'
  }
}
